import React, { PureComponent } from 'react';
import { connect } from 'shalala';

import { Http } from '../../../../support';
import { useStore } from '../../../../store';
import LoadingButton from '../../../../facturotopia/LoadingButton';

const mapState = (store) => {
  return {
    xml_storage: store.admin.reportes.facturacion.xml_storage,
  };
};

const mapActions = (actions) => {
  return actions.admin.reportes.facturacion.xml_storage;
};

class ReporteFacturacionXmlStorageDownload extends PureComponent {
  state = {
    busy: false,
  };

  handleOnDownloadActionClick = async () => {
    const { filters } = this.props.xml_storage;

    this.setState({
      busy: true,
    });

    const params = {
      download: 1,
      from: filters.from,
      to: filters.to,
    };

    try {
      const headers = {};

      const response = await Http.get(`${window.BONJOUR_URL}/app/admin/reportes/storage`, {
        params,
        responseType: 'blob',
        headers,
      });

      window.downloadFromHttpResponse(response);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No podemos descargar el archivo',
      });
    } finally {
      this.setState({
        busy: false,
      });
    }
  };

  render() {
    const { busy } = this.state;

    return (
      <LoadingButton
        variant="secondary"
        loading={busy}
        onClick={this.handleOnDownloadActionClick.bind(this, undefined)}
      >
        {busy === true ? 'Descargando' : 'Descargar'}
      </LoadingButton>
    );
  }
}

export default connect(useStore, mapState, mapActions)(ReporteFacturacionXmlStorageDownload);
